<div class="reload-error-modal text-center p-4">
    <!-- Inline SVG: this modal shows when the network is down, so the icon can't be a file to download -->
    <svg class="error-icon" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="32" fill="#FDE5E5" />
        <path d="M24 24l16 16M40 24L24 40" stroke="#EF2727" stroke-width="3" stroke-linecap="round" />
    </svg>

    <h4 class="fs-24 fw-800 m-0 mt-3 mb-2 modal-heading">
        Something went wrong
    </h4>

    <p class="fs-16 fw-500 m-0 mb-4 modal-subtext">
        We were unable to reach the server. Please reload the page and try again.
    </p>

    <button type="button" class="btn btn-primary fw-600 w-100" (click)="reload()">
        Reload
    </button>
</div>
